<template>
  <div id="change-barcode">
    <p>ACROSS倉庫にある商品のバーコードラベルの貼り替え依頼を作成することができます</p>
    <div id="product-input" class="card">
      <div class="mr-b-10">
        <fixed-header v-show="isShowFixedHeader" :textBtnAdd="'+ セット追加'" :textBtnRegister="'依頼する'" @handleClickAdd="openShippingProductAddModal = true" @handleClickRegister="submit()"/>
        <button class="btn btn-primary" @click="openShippingProductAddModal = true">
          + セット追加
        </button>
      </div>
      <table class="set-table" v-if="sets.length > 0">
        <thead>
          <tr>
            <th>変更元商品</th>
            <th>変更先商品</th>
            <th class="w-120">数量</th>
            <th class="w-120"></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(set, index) in sets">
            <tr :key="`row-${index}`" class="row-data" :class="{'has-errors' : set.errors.length}">
              <!-- 変更元商品 -->
              <td>
                <div class="flexbox-between gap-10">
                  <div class="original-products">
                    <img :src="set.originalProduct.image" />
                    <div>
                      <div class="font-bold" :title="set.originalProduct.itemName">{{ sliceProductName(set.originalProduct.itemName) }}</div>
                      <div class="flexbox">
                        <span class="mr-r-10"><b>ASIN: </b>{{ set.originalProduct.asin }} </span>
                        <span><b>SKU: </b>{{ set.originalProduct.sku }}</span>
                      </div>
                      <div class="flexbox">
                        <span class="mr-r-10"><b>商品ID: </b>{{ set.originalProduct.itemId }}</span>
                        <span><b>商品ラベル: </b>{{ set.originalProduct.fnsku }}</span>
                      </div>
                      <div>
                        <b>ACROSS在庫数: </b>{{ set.originalProduct.acrossQuantity }}個
                      </div>
                    </div>
                  </div>
                  <div class="flexbox-between gap-10">
                    <button
                      class="btn btn-warning"
                      @click="openOriginalProductsModal(index)"
                    >
                      変更する
                    </button>
                    <b>▶</b>
                  </div>
                </div>
              </td>

              <!-- 変更先商品 -->
              <td>
                <div v-if="set.replacementProduct" class="replace-products">
                  <div class="product-info">
                    <img :src="set.replacementProduct.image" />
                    <div>
                      <div class="font-bold" :title="set.replacementProduct.itemName">{{ sliceProductName(set.replacementProduct.itemName) }}</div>
                      <div class="">
                        <b>ASIN: </b>{{ set.replacementProduct.asin }}
                      </div>
                      <div class="flexbox gap-10">
                        <b>商品ラベル: </b>
                        <div>
                          <select
                            v-if="Object.keys(set.replacementProduct.fnskus).length > 1"
                            name="fnsku-kbn"
                            v-model="set.replacementProduct.fnsku"
                            :id="`fnsku-kbn-select-${set.replacementProduct.asin}`"
                            class="form-control"
                            :class="{'bg-no-input': !set.replacementProduct.fnsku}"
                            @change="changeFnsku(set.replacementProduct)"
                          >
                            <option value="">選択してください</option>
                            <option v-for="(val, key) in set.replacementProduct.fnskus" :key="key" :value="key">{{ val }}</option>
                          </select>
                          <div v-else>
                            {{ set.replacementProduct.fnsku }}
                          </div>
                        </div>
                        <div>
                          <b>SKU:</b>{{ set.replacementProduct.sku }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    class="btn btn-warning"
                    @click="openReplacementProductsModal(index)"
                  >
                    変更する
                  </button>
                </div>

                <button
                  v-else
                  class="btn btn-primary"
                  @click="openReplacementProductsModal(index)"
                >
                  商品を選択
                </button>
              </td>

              <!-- 数量 -->
              <td class="text-center w-120">
                <input type="number" class="form-control w-100" min="1" v-model.number="set.quantity" />
              </td>

              <!-- 操作 -->
              <td class="text-center">
                <button class="btn btn-delete-selected-product" @click="removeSet(index)">
                  削除
                </button>
              </td>

            </tr>
            <tr v-if="set.errors.length" :key="`errors${index}`" class="row-errors">
              <td colspan="4">
                <ul class="error-list">
                  <li v-for="(err, i) in set.errors" :key="i">
                    {{ err }}
                  </li>
                </ul>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="action-bar">
        <button v-if="sets.length > 0" class="btn btn-primary" @click="submit">
          依頼する
          <i class="fa fa-check fa-lg mr-l-5" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <shipping-product-add
      v-if="openShippingProductAddModal"
      ref="shippingMultiProductAddModal"
      :defaultDescription="'バーコード貼り替え依頼をする商品を選択してください'"
      :columns="originalProductColumns"
      :selectedProducts="selectedShippingProducts"
      @close="closeModalProductAdd"
      @handleSelectedProduct="handleAddSet"
      @handleSelectedProducts="handleAddSets"
    />
    <delivery-product-add
      v-if="openDeliveryProductAddModal"
      ref="deliveryProductAddModal"
      :defaultDescription="'バーコード貼り替え依頼をする商品を選択してください'"
      :columns="replacementProductColumns"
      :selectedProducts="selectedDeliveyProducts"
      @close="closeModalDeliveryProductAdd"
      @handleSelectedProduct="handleAddReplacementProduct"
    />
    <modal-confirm
      v-if="openConfirmModal"
      :message="confirmMessage"
      @confirm="submitChangeBarcode"
      @close="closeModalConfirm"
    />
    <modal-alert
      v-if="openAlertModal"
      :message="alertMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeModalAlert"
    />
  </div>
</template>

<script>
import ShippingProductAdd from '@/view/warehouseAcross/components/ShippingMultiChannelProductAdd'
import DeliveryProductAdd from '@/view/warehouseAcross/components/DeliveryProductAdd'
import FixedHeader from '@/view/warehouseAcross/components/FixedHeader'
import ModalConfirm from '@/components/ModalConfirm'
import ModalAlert from '@/components/ModalAlert'
import { mapGetters } from 'vuex'
import WarehouseAcrossService from '@/services/warehouseacrossservice'

export default {
  components: {
    FixedHeader,
    ShippingProductAdd,
    DeliveryProductAdd,
    ModalConfirm,
    ModalAlert
  },
  data () {
    return {
      loader: null,
      activeIndex: null,
      isShowFixedHeader: false,
      openShippingProductAddModal: false,
      openDeliveryProductAddModal: false,
      sets: [],
      openConfirmModal: false,
      confirmMessage: 'バーコード変更を実行します。よろしいですか？',
      openAlertModal: false,
      alertMessage: 'バーコード変更が正常に完了しました。'
    }
  },
  computed: {
    ...mapGetters({
      iconUrls: 'getWareHouseIcons'
    }),
    selectedShippingProducts () {
      return this.sets.map(s => s.originalProduct)
    },
    selectedDeliveyProducts () {
      return this.sets
        .filter(s => s && s.replacementProduct)
        .map(s => s.replacementProduct)
    },
    originalProductColumns () {
      if (this.activeIndex === null) {
        return [
          {
            title: '<input type="checkbox" id="checkbox-all">',
            name: 'checkBoxAll',
            customCell: true,
            cellClass: 'text-center',
            headerClass: 'w-30 th-checkbox-all',
            sortable: false,
            bgColor: '#deebf7',
            color: '#595959'
          },
          {
            title: 'ステータス',
            name: 'status',
            customCell: true,
            cellClass: 'text-center',
            headerClass: 'w-100',
            sortable: false,
            bgColor: '#deebf7',
            color: '#595959'
          },
          {
            title: '商品情報',
            name: 'productName',
            cellClass: 'text-left',
            customCell: true,
            headerClass: 'product-name',
            sortable: false,
            textAlign: 'left',
            bgColor: '#deebf7',
            color: '#595959'
          },
          {
            title: 'ACROSS在庫数',
            name: 'acrossQuantity',
            cellClass: 'text-right',
            customCell: true,
            headerClass: 'w-150',
            sortable: false,
            textAlign: 'right',
            bgColor: '#deebf7',
            color: '#595959'
          },
          {
            title: '',
            name: 'action',
            customCell: true,
            cellClass: 'text-center',
            headerClass: 'w-75',
            sortable: false,
            bgColor: '#deebf7',
            color: '#595959'
          }
        ]
      }

      return [
        {
          title: 'ステータス',
          name: 'status',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-100',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: '商品情報',
          name: 'productName',
          cellClass: 'text-left',
          customCell: true,
          headerClass: 'product-name',
          sortable: false,
          textAlign: 'left',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: 'ACROSS在庫数',
          name: 'acrossQuantity',
          cellClass: 'text-right',
          customCell: true,
          headerClass: 'w-150',
          sortable: false,
          textAlign: 'right',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: '',
          name: 'action',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-75',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        }
      ]
    },
    replacementProductColumns () {
      return [
        {
          title: 'ステータス',
          name: 'status',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-100',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: '商品情報',
          name: 'productName',
          cellClass: 'text-left',
          customCell: true,
          headerClass: 'product-name',
          sortable: false,
          textAlign: 'left',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: 'Amazon在庫数',
          name: 'amazonQuantity',
          cellClass: 'text-right',
          customCell: true,
          headerClass: 'w-150',
          sortable: false,
          textAlign: 'right',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: 'ACROSS在庫数',
          name: 'acrossQuantity',
          cellClass: 'text-right',
          customCell: true,
          headerClass: 'w-150',
          sortable: false,
          textAlign: 'right',
          bgColor: '#deebf7',
          color: '#595959'
        },
        {
          title: '',
          name: 'action',
          customCell: true,
          cellClass: 'text-center',
          headerClass: 'w-75',
          sortable: false,
          bgColor: '#deebf7',
          color: '#595959'
        }
      ]
    }
  },
  created () {
    this.$events.listen('send-data', this.handleAddSets)
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    sliceProductName (productName, length = 30) {
      if (productName.length <= length) return productName

      return productName.slice(0, length / 2) + ' ... ' + productName.slice(-(length / 2))
    },
    handleScroll () {
      const fixedHeader = document.getElementById('product-input')
      if (fixedHeader) {
        const initialOffset = fixedHeader.getBoundingClientRect().top + window.scrollY
        this.isShowFixedHeader = window.scrollY >= initialOffset
      }
    },
    closeModalProductAdd () {
      this.activeIndex = null
      $('#shipping-product-add-modal').modal('hide')
      this.openShippingProductAddModal = false
    },
    closeModalDeliveryProductAdd () {
      this.activeIndex = null
      $('#delivery-product-add-modal').modal('hide')
      this.openDeliveryProductAddModal = false
    },
    closeModalConfirm () {
      $('#confirm-alert').modal('hide')
      this.openConfirmModal = false
    },
    closeModalAlert () {
      $('#myModal').modal('hide')
      this.openAlertModal = false
    },
    handleAddSet (product) {
      if (this.activeIndex === null) {
        this.sets.push({
          originalProduct: {...product},
          replacementProduct: null,
          quantity: product.acrossQuantity || 0,
          errors: []
        })
        return
      }

      const set = this.sets[this.activeIndex]
      set.originalProduct = {...product}
      set.quantity = product.acrossQuantity || 0
      set.errors = []

      if (set.replacementProduct) {
        set.replacementProduct.dueDateManageFlg = product.dueDateManageFlg
        set.replacementProduct.expirationDate = product.expirationDate
      }
      this.closeModalProductAdd()
    },
    handleAddSets (products) {
      if (products && products.length > 0) {
        products.forEach(product => {
          this.sets.push({
            originalProduct: {...product},
            replacementProduct: null,
            quantity: product.acrossQuantity || 0,
            errors: []
          })
        })
      }
    },
    removeSet (index) {
      this.sets.splice(index, 1)
    },
    openOriginalProductsModal (index) {
      this.activeIndex = index
      this.openShippingProductAddModal = true
    },
    openReplacementProductsModal (index) {
      this.activeIndex = index
      this.openDeliveryProductAddModal = true
    },
    handleAddReplacementProduct (product) {
      const set = this.sets[this.activeIndex]
      const originalProduct = set.originalProduct
      set.replacementProduct = {...product, goodsLabelAttachKbn: '1', dueDateManageFlg: originalProduct.dueDateManageFlg, expirationDate: originalProduct.expirationDate}
      this.closeModalDeliveryProductAdd()
    },
    changeFnsku (product) {
      product.sku = product.skus[product.fnsku]
    },
    async submit () {
      const valid = await this.validateAll()

      if (!valid) {
        this.$store.commit('toggleModal', {
          show: true,
          message: '入力内容にエラーがあります。確認してください。'
        })
        return false
      }

      this.openConfirmModal = true
    },
    async validateAll () {
      const results = this.sets.map(s => this.validateSet(s))
      return results.every(r => r)
    },
    validateSet (set) {
      set.errors = []
      if (!set.originalProduct) {
        set.errors.push('変更元商品がありません')
      }
      set.originalProduct.quantity = set.quantity

      if (!set.quantity || set.quantity <= 0) {
        set.errors.push('数量は1以上で入力してください')
      }

      if (
        set.originalProduct &&
        set.quantity > set.originalProduct.acrossQuantity
      ) {
        set.errors.push('数量はACROSS在庫数より少なく入力してください')
      }

      if (!set.replacementProduct) {
        set.errors.push('変更先商品を選択してください')
      } else {
        set.replacementProduct.quantity = set.quantity
        if (!set.replacementProduct.sku) {
          set.errors.push('SKUを入力してください')
        }

        if (!set.replacementProduct.fnsku) {
          set.errors.push('FNSKUを選択してください')
        }
      }

      return set.errors.length === 0
    },
    async submitChangeBarcode () {
      this.loader = this.$loading.show()
      await WarehouseAcrossService.changeBarcode({ sets: this.sets })
        .then((response) => {
          this.closeModalConfirm()
          this.sets = []
          this.openAlertModal = true
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  },
  unmouted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
#change-barcode {
  padding: 20px;
  overflow: auto;
}
.card {
  padding: 20px;
  background: #fff;
  min-width: max-content;
  max-width: 1500px;
}
.set-table {
  width: 100%;
  max-width: 1500px;
  border-collapse: collapse;
  border: 1px solid #ccc;
  td, th {
    border-collapse: collapse;
  }
  tr.row-errors {
    border-bottom: 1px solid #ccc;
    color: red;
  }
  tr.row-data {
    border-bottom: 1px solid #ccc;
  }
  tr.row-data.has-errors {
    border-bottom: unset;
  }
  .search-table thead th {
    position: sticky;
    top: 0;
  }
  th {
    padding: 10px 5px;
    color: #595959;
    background: #deebf7;
  }
  td {
    padding: 5px 10px;
    height: 35px;
    background-color: #fff;
  }
  th,
  td {
    min-width: 120px;
  }
}
.set-table td:first-child, .set-table td:nth-child(2) {
  min-width: 550px;
}
.original-products, .replace-products {
  display: flex;
  gap: 10px;
  align-items: center;
  img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 4px;
  }
}
.replace-products {
  justify-content: space-between;
  .product-info {
    display: flex;
    gap: 10px;
    align-items: center;
  }
}
.action-bar {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

.btn-delete-selected-product {
  background-color: #ffffff;
  border: 1px solid #a94442;
  color: #a94442;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/ChangeBarcode.vue